require('./capitalize');
require('./lowercase');
require('./currency');
